module.exports = require("@swa-ui/authentication/src/components/NewPassword/NewPassword.module.scss");